export const NearbyCommunities = {
    DEFAULT_RADIUS: 20,
    MIN_RADIUS: 0,
    MAX_RADIUS: 100,
  };